import script from "./Speak.vue?vue&type=script&setup=true&lang=js"
export * from "./Speak.vue?vue&type=script&setup=true&lang=js"

import "./Speak.vue?vue&type=style&index=0&id=3e43aa8a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e43aa8a"]])

export default __exports__